import { useEffect } from 'react';

/**
 * useGlobalSearchShortcut — listens for ⌘K / Ctrl+K (without Shift) and
 * calls onTrigger. Binds at window level so it works from any page.
 *
 * DD1 (design §6.2): Cmd-K → Search palette (was Ask widget; Ask remapped to Cmd-J in T02).
 */
export function useGlobalSearchShortcut(onTrigger: () => void): void {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'k' && !e.shiftKey) {
        e.preventDefault();
        onTrigger();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onTrigger]);
}
